module.exports = __webpack_public_path__ + "img/09_terminal_parts.d17c7d84.jpg";